

































































































import { Component, Vue, Prop } from 'vue-property-decorator'

interface estimation {
    surface: number
    exposition: string
    stage: string
    exterieur: string
    parking: number
    prix: {
        base: number
        parking: number
        exterieur: number
    }
    favori: boolean
}

@Component({
    filters: {
        numberWithSpaces(value: string) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        },
        formatParking(value: number) {
            switch (value) {
                case 0:
                    return 'Aucun'
                case 1:
                    return '1 place'
                default:
                    return `${value} places`
            }
        },
        mathFloor(value: number) {
            return Math.floor(value)
        },
    },
})
export default class Projet extends Vue {
    @Prop({
        default: [],
    })
    estimations: Array<estimation>

    tooltips = {
        appartPrice: `
            <p>
                Les montants indiqués dans la grille représentent toutes les combinaisons possibles liées aux
                choix de personnalisation de l’appartement (surface, étage, exposition, ...). Plus vous aurez
                fourni de critères précis, moins vous aurez de choix de propositions.
            </p>
            <p>
                <i class="fa fa-warning" style="font-size: 16pt;"></i> Cette estimation de prix de vaut pas offre de vente, le budget définitif sera connu à l’étape 4 et sera confirmé dans le contrat de réservation.
            </p>
        `,
        spacesPrice: `
            <p>
                <div>
                    Ce prix correspond à l’ensemble des espaces que vous avez indiqué souhaiter acheter à
                    plusieurs. Le coût total de chaque espace a été divisé entre les différents membres du
                    groupe.
                </div>
                <div>
                    Ce prix pourra évoluer si vous quittez ou rejoignez un nouveau groupe correspondant à un
                    espace.
                </div>
            </p>
            <p>
                <i class="fa fa-warning" style="font-size: 16pt;"></i> Cette estimation de prix de vaut pas offre de vente, le budget définitif sera connu à l’étape 4 et sera confirmé dans le contrat de réservation.
            </p>
        `,
        bookmark: `
            Indiquez-nous votre choix favori dans la grille. Nous tâcherons de privilégier cette
            configuration lors de l’élaboration des plans de la résidence.
        `,
    }

    mounted() {
        requestAnimationFrame(() => {
            ;(<any>$('.popover-dismiss')).popover({
                trigger: 'hover',
                container: 'body',
                boundary: 'window',
            })
        })
    }

    toggle(estimation) {
        this.estimations.forEach(estimation => {
            estimation.favori = false
        })
        estimation.favori = true

        this.$emit('choose', estimation.raw)
    }
}
